// extracted by mini-css-extract-plugin
export var required = "_oa-0";